import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ReadingState {
  /** Map doc_id → last section_id viewed */
  positions: Record<string, string>;
  setPosition: (docId: string, sectionId: string) => void;
  getPosition: (docId: string) => string | undefined;
}

export const useReading = create<ReadingState>()(
  persist(
    (set, get) => ({
      positions: {},
      setPosition: (docId, sectionId) =>
        set({ positions: { ...get().positions, [docId]: sectionId } }),
      getPosition: (docId) => get().positions[docId],
    }),
    { name: "docustudio-reading" },
  ),
);
